module.exports = __webpack_public_path__ + "assets/svg/UI/employee-white-7cf296.svg";